import {TGetListingRequest} from 'plugins/modules/listing/api/api';

interface IListingLoaders<Request> {
    isFetching: boolean;
    originalArgs?: Request;
}

export const useListingLoaders = <Request extends TGetListingRequest>({
    isFetching,
    originalArgs,
}: IListingLoaders<Request>) => {
    let loadDirection: 'next' | 'prev' | undefined;
    if (originalArgs) {
        const {lastPage, firstPage, isManual} = originalArgs.pagination;
        const {pageNumber} = originalArgs;

        if (lastPage === pageNumber && !isManual) {
            loadDirection = 'next';
        } else if (firstPage === pageNumber && !isManual) {
            loadDirection = 'prev';
        } else {
            loadDirection = undefined;
        }
    }

    const isLoading = isFetching && !loadDirection;
    const isLoadingPrev = 'prev' === loadDirection && isFetching;
    const isLoadingNext = 'next' === loadDirection && isFetching;

    return {
        isLoading,
        isFetching,
        isLoadingNext,
        isLoadingPrev,
    };
};
